import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Autocomplete } from '@components/Autocomplete'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { SearchPanelContainer } from '@components/Search'
import Scroll from '@components/Scroll'
import EmployeeSearchResults from './EmployeeSearchResults'
import Pagination from '@components/Pagination'
import Spinner from '@components/spinner'
import FilterGroup from '@components/FilterGroup'
import { StatusFilter } from '@components/StatusFilter'
import ACL from '@components/ACL/ACL'

class EmployeeSearchPanel extends Component {
  static propTypes = {
    employeeSearchStore: PropTypes.object,
    modalStore: PropTypes.object,
    staticData: PropTypes.object,
    atheneumOfficeStore: PropTypes.object,
    baseUrl: PropTypes.string
  }

  constructor (props) {
    super(props)
    const { employeeSearchStore } = props
    employeeSearchStore.search()
  }

  renderLoader () {
    return <Spinner />
  }

  onRefresh = () => {
    this.props.employeeSearchStore.clearSearch()
    this.search()
  }

  searchOnEnter = e => {
    if (e.key === 'Enter') {
      return this.search()
    }
  }

  search = event => {
    this.props.employeeSearchStore.search()
    this.props.employeeSearchStore.page = 1
  }

  render () {
    const {
      query,
      employeesCount,
      changePage,
      statusOptions
    } = this.props.employeeSearchStore
    const { baseUrl, staticData, atheneumOfficeStore } = this.props
    return (
      <div className='expert-search-panel'>
        <div className='expert-search-panel-container'>
          <SearchPanelContainer
            thin
            buttonProps={{
              buttonText: 'Add new employee',
              onClick: () =>
                this.props.modalStore.show({
                  type: 'EMPLOYEE_FORM'
                }),
              roles: ['Accounting', 'Admin']
            }}
            searchTitle='Filter contacts'
            onClearSearch={this.onRefresh}
          >
            <div onSubmit={this.search}>
              <FilterGroup
                label='First name, last name, email'
                onSearch={this.search}
              >
                <input
                  value={query.q}
                  onKeyDown={this.searchOnEnter}
                  onChange={e => {
                    query.q = e.target.value
                  }}
                />
              </FilterGroup>
              <FilterGroup>
                <StatusFilter
                  single
                  required
                  selectedItems={[query.employeeStatus]}
                  items={statusOptions}
                  onChange={selected => {
                    query.employeeStatus = selected[0]
                    this.search()
                  }}
                />
              </FilterGroup>
              <ACL roles={['Accounting', 'Admin']}>
                <FilterGroup label='Permissions'>
                  <Autocomplete
                    showResultsOnEmptyInput
                    value={query.permissions}
                    itemToString={item => item && item.prettyName}
                    onChange={value => {
                      query.permissions = value
                      this.search()
                    }}
                    options={staticData.permissions}
                  />
                </FilterGroup>
              </ACL>
              <FilterGroup label='Office'>
                <Autocomplete
                  showResultsOnEmptyInput
                  value={query.office}
                  itemToString={item => item && `Atheneum ${item.name}`}
                  onChange={value => {
                    query.office = value
                    this.search()
                  }}
                  options={atheneumOfficeStore.atheneumOffices}
                />
              </FilterGroup>
              <ACL roles={['Accounting', 'Admin']}>
                <FilterGroup label='Position'>
                  <Autocomplete
                    showResultsOnEmptyInput
                    value={query.employeePosition}
                    itemToString={item => item && item.name}
                    onChange={value => {
                      query.employeePosition = value
                      this.search()
                    }}
                    options={staticData.employeePositions}
                  />
                </FilterGroup>
              </ACL>
            </div>
          </SearchPanelContainer>
          <div className='search-panel-results'>
            <Scroll>
              <EmployeeSearchResults baseUrl={baseUrl} />
              <Pagination
                total={employeesCount}
                perPage={10}
                page={query.page}
                onChange={p => changePage(p)}
              />
            </Scroll>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(
  inject(
    'employeeSearchStore',
    'modalStore',
    'staticData',
    'atheneumOfficeStore'
  )(observer(EmployeeSearchPanel))
)
